import React from 'react';

const FriendCard = ({ friend, onMessage, onRemove }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'online':
        return 'bg-green-500';
      case 'offline':
        return 'bg-gray-400';
      case 'away':
        return 'bg-yellow-500';
      default:
        return 'bg-gray-400';
    }
  };

  const getLevelColor = (level) => {
    const colors = {
      'Quiz Master': 'text-purple-600 bg-purple-100 dark:bg-purple-900 dark:text-purple-300',
      'Subject Explorer': 'text-blue-600 bg-blue-100 dark:bg-blue-900 dark:text-blue-300',
      'Streak Keeper': 'text-orange-600 bg-orange-100 dark:bg-orange-900 dark:text-orange-300',
      'First Steps': 'text-green-600 bg-green-100 dark:bg-green-900 dark:text-green-300',
      'Content Creator': 'text-pink-600 bg-pink-100 dark:bg-pink-900 dark:text-pink-300'
    };
    return colors[level] || colors['First Steps'];
  };

  return (
    <div className="flex items-center justify-between p-4 bg-gray-50 dark:bg-gray-700 rounded-2xl hover:bg-gray-100 dark:hover:bg-gray-600 transition-colors">
      <div className="flex items-center gap-4">
        <div className="relative">
          <div className="w-12 h-12 rounded-full bg-gradient-to-br from-blue-400 to-purple-500 flex items-center justify-center text-white font-semibold">
            {friend.avatar ? (
              <img src={friend.avatar} alt={friend.name} className="w-full h-full rounded-full object-cover" />
            ) : (
              friend.name.charAt(0)
            )}
          </div>
          <div className={`absolute -bottom-1 -right-1 w-4 h-4 rounded-full border-2 border-white dark:border-gray-700 ${getStatusColor(friend.status)}`}></div>
        </div>
        <div>
          <h4 className="font-semibold text-gray-800 dark:text-white">{friend.name}</h4>
          <div className="flex items-center gap-2">
            <span className={`inline-block px-2 py-1 rounded-full text-xs font-medium ${getLevelColor(friend.level)}`}>
              {friend.level}
            </span>
            <span className="text-sm text-gray-500 dark:text-gray-400 capitalize">{friend.status}</span>
          </div>
        </div>
      </div>
      <div className="flex items-center gap-2">
        {friend.status === 'online' && (
          <button
            onClick={() => onMessage && onMessage(friend)}
            className="p-2 text-blue-500 hover:text-blue-600 hover:bg-blue-50 dark:hover:bg-blue-900/20 rounded-full transition-colors"
            title="Send message"
          >
            💬
          </button>
        )}
        <button
          onClick={() => onRemove && onRemove(friend)}
          className="p-2 text-red-500 hover:text-red-600 hover:bg-red-50 dark:hover:bg-red-900/20 rounded-full transition-colors"
          title="Remove friend"
        >
          ✕
        </button>
      </div>
    </div>
  );
};

export default FriendCard; 